import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Dropdown } from 'semantic-ui-react';
import './DocumentsContainer.less';

const initialState = { windowWidth: 0 }

const options = [
    {
        key: 'section_0',
        text: 'Personally Identifiable Information',
        value: '0',
    },

    {
        key: 'section_1',
        text: 'Non-Personally Identifiable Information',
        value: '1',
    },
    {
        key: 'section_2',
        text: 'Instances Where We Are Required To Share Your Information',
        value: '2',
    },
    {
        key: 'section_3',
        text: 'What Happens in the Event of a Change of Control',
        value: '3',
    },

    {
        key: 'section_4',
        text: 'Testimonials',
        value: '4',
    },
    {
        key: 'section_5',
        text: 'Cookies',
        value: '5',
    },
    {
        key: 'section_6',
        text: 'Sharing or Selling Your Information',
        value: '6',
    },
    {
        key: 'section_7',
        text: 'Social Media Widgets',
        value: '7',
    },
    {
        key: 'section_8',
        text: 'Privacy Shield',
        value: '8',
    },
    {
        key: 'section_9',
        text: 'How You Can Update Your Information console',
        value: '9',
    },
    {
        key: 'section_10',
        text: 'Links to Other Sites',
        value: '10',
    },
    {
        key: 'section_11',
        text: 'Privacy Policy Changes',
        value: '11',
    },
    {
        key: 'section_12',
        text: 'How to Contact Us',
        value: '11',
    },

];
class PrivacyPolicyContainer extends Component {

    constructor(props) {
        super(props);
        this.state = initialState;
        for (let i = 0; i < 13; i++) {
            this['section_' + i] = createRef();
            this['link_' + i] = createRef();
        }
        this.sectionOffsetTop = [];
        this.section = 0;

    }

    onLinkClick = (event) => {
        const section = event.target.attributes.value.value;

        this[`section_${section}`].current.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });

    }

    onItemClick = (event, data) => {

        const section = data.value;

        this[`section_${section}`].current.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });

    }

    componentDidMount() {
        window.addEventListener('resize', this.updateWindowDimensions);
        this.updateWindowDimensions();
        /*for (let i = 0; i < 13; i++) {
            if (i > 0) {
                this.sectionOffsetTop[i - 1].max = this[`section_${i}`].current.offsetTop - 1;
            }

            this.sectionOffsetTop.push({ min: this[`section_${i}`].current.offsetTop });

            if (i == 12) {
                this.sectionOffsetTop[i].max = this.sectionOffsetTop[i].min + 1000;
            }

        }*/

       
    }

    handleScroll = (event) => {


        if (event.target.scrollTop <= this.sectionOffsetTop[0].min) {

            this[`link_0`].current.classList.add("active");
            if (this.section != 0)
                this[`link_${this.section}`].current.classList.remove("active");
            this.section = 0;
        }
        else {
            for (let i = 1; i < 13; i++) {
                const currentScrollTop = event.target.scrollTop + 84;
                if (currentScrollTop >= this.sectionOffsetTop[i].min && currentScrollTop <= this.sectionOffsetTop[i].max) {
                    if (this.section != i) {
                        this[`link_${i}`].current.classList.add("active");

                        this[`link_${this.section}`].current.classList.remove("active");


                        this.section = i;
                    }


                }
            }
        }



    }

    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth });

    }
    render() {
        return (
            <div className="privacy-policy-main-container">
                {this.state.windowWidth < 768 &&
                    <div className="dropdown-container">
                        <Dropdown placeholder="Select section" fluid selection options={options} onChange={this.onItemClick}>

                        </Dropdown>
                    </div>
                }
                {this.state.windowWidth >= 768 && <div className="links">
                    {
                        options.map((option, index) => {
                            return <div key={index} className="link" value={`${option.value}`} ref={this[`link_${option.value}`]} onClick={this.onLinkClick}>
                                {option.text}
                            </div>
                        })
                    }

                </div>}
                <div className="content" onScroll={this.handleScroll}>
                    <div className="main-header">
                        Syndafy&nbsp;<div className="emphasize">Privacy Policy</div>
                    </div>

                    <div className="big-heading">
                        Product Name: ServiceGrace
                    </div>
                    <p>Syndafy Inc. (“Syndafy” or “Company”) is committed to protecting the privacy of its clients and visitors, and to maintaining the confidentiality and security of personal information you may provide to us. This Privacy Policy describes the information we may collect about or from you, how we use and safeguard it, and how you may contact us if you need to update your information or ask us any related questions. This Privacy Policy applies only to information collected through our Website and app and not to information collected offline. To learn more, please keep reading.</p>

                    <div className="small-heading" >
                        Information We Collect and How We Use It
                    </div>
                    <div className="small-heading" ref={this[`section_0`]}>
                        Personally Identifiable Information
                    </div>
                    <p>Syndafy will not rent or sell your personally identifiable information to others. We may store personal information in locations outside the direct control of Syndafy (for instance, on servers or databases co-located with hosting providers). Any personally identifiable information you elect to make publicly available on our Sites or the Syndafy Platform, such as posting comments, will be available to others. If you remove information that you have made public on our Sites or the Syndafy Platform, copies may remain viewable in cached and archived pages of our Sites or the Syndafy Platform, or if other users have copied or saved that information. We may collect other personally identifying information from you, such as your social security number, bank account number, credit card number, financial records, driver's license number, and other private information related to certain products and services. We may also receive other personally identifying information about you, from external credit rating agencies or financial institutions.
                    We use your personally identifying information only as necessary. We maintain physical, electronic, and procedural safeguards to store and protect this information. We grant access to your information only to our employees, contractors, agents, service providers, and affiliated organization that (i) need to know such information to process it on our behalf or to provide services to you, and (ii) that have agreed not to disclose it to others. Syndafy may share your personally identifiable information. We may also disclose your information, including personal information and non-personal information, in certain other circumstances, as described below.
The Syndafy Platform relies on us connecting you to Vendors. You agree that we are giving Vendors access to your personally identifiable information, such as name, phone numbers, addresses and email addresses. If you are a Vendor, you agree to let Syndafy share your name, phone numbers, addresses and email addresses with Clients.</p>
                    <div className="small-heading" ref={this[`section_1`]}>
                        Non-Personally Identifiable Information
                    </div>
                    <p>We may share non-personally identifiable information (such as anonymous usage data, referring/exit pages and URLs, platform types, number of clicks, etc.) with interested third parties to help them understand the usage patterns for certain Syndafy Platforms and those of our partners. Our partners also have the option to publish the results for their websites on the Syndafy Platform. Such results consist solely of non-personally identifiable information. If you choose to publish such results on the Syndafy Platform or Website (for example, in our results gallery), you understand and agree that this information, along with any personally identifiable information you choose to make available in connection with such results, will be made publicly available. By publishing your results on the Syndafy Platform or Website, you agree that you have obtained all necessary consents to make such information public and that doing so will not violate any laws. If you remove information that you have made public on the Syndafy Platform or Website, copies may remain viewable in cached and archived pages of the Syndafy Platform or Website, or if other users have copied or saved that information. Non-personally identifiable information may be stored indefinitely.</p>
                    <div className="small-heading" ref={this[`section_2`]}>
                        Instances Where We Are Required To Share Your Information
                    </div>
                    <p>Syndafy will disclose your information where required to do so by law, if subject to subpoena or other legal proceeding or if we reasonably believe that such action is necessary to (a) comply with the law and the reasonable requests of law enforcement; (b) to enforce our Terms of Service or to protect the security or integrity of our Service; and/or (c) to exercise or protect the rights, property, or personal safety of Syndafy, our users or others.</p>
                    <div className="small-heading" ref={this[`section_3`]}>
                        What Happens in the Event of a Change of Control
                    </div>
                    <p>
                        We may buy or sell/divest/transfer the Company (including any shares in the company), or any combination of its products, services, assets and/or businesses. Your information such as customer names and email addresses, and other User information related to the Syndafy Platform may be among the items sold or otherwise transferred in these types of transactions. We may also sell, assign or otherwise transfer such information in the course of corporate divestitures, mergers, acquisitions, bankruptcies, dissolutions, reorganizations, liquidations, similar transactions or proceedings involving all or a portion of the company. You will be notified via email and/or a prominent notice on our Website of any change in ownership or uses of your personal information, as well as any choices you may have regarding your personal information. If the Company is involved in a merger, acquisition, or asset sale, or in the unlikely event that Company were to go out of business or enter bankruptcy, user information may be one of the assets that is transferred or acquired by a third party. By using our Website, you acknowledge and agree that such transfers may occur, and that any acquirer of the Company may continue to use your personal information as set forth in this policy.
                    </p>
                    <div className="small-heading" ref={this[`section_4`]}>
                        Testimonials
                    </div>
                    <p>We may display personal testimonials of satisfied customers on our Website in addition to other endorsements. With your consent, we may post your testimonial along with your name. If you wish to update or delete your testimonial, you can contact us.</p>
                    <div className="small-heading" ref={this[`section_5`]}>
                        Cookies
                    </div>
                    <p>
                        A cookie is a string of information that a website stores on a visitor’s computer, and that the visitor’s browser provides to the website each time the visitor returns. We use cookies to help us identify and track visitors, their usage of our Website, and their website access preferences. Website visitors who do not wish to have cookies placed on their computers should set their browsers to refuse cookies before using our Website, with the drawback that certain features of the Website may not function properly without the aid of cookies. When you visit our Website and submit our inquiry forms or send us an email message, we collect any personally identifying information that you provide, such as your name, email address, phone number, address, and any comments that you enter. We use this information to respond to your inquiry about our company and services. We may use and share your information across our Websites, SMS, APIs, email notifications, applications, buttons, widgets, ads, commerce services, and any other covered services that link to this Privacy Policy. If we believe in good faith that disclosure of your information is (i) legally required in response to a subpoena, court order, or other governmental request, and/or (ii) legally required or reasonably necessary to protect our property or rights, or those of third parties or the public at large, we will disclose the information.
                    </p>
                    <div className="small-heading" ref={this[`section_6`]}>
                        Sharing or Selling Your Information
                    </div>
                    <p>Syndafy does not sell, rent, share, or otherwise distribute your personally identifying information to any other external parties beyond those described above, for marketing or any other purpose. Syndafy is concerned with protecting your privacy and data, but we cannot ensure or warrant the security of any information you transmit to Syndafy or guarantee that your information on the Syndafy Platform may not be accessed, disclosed, altered or destroyed by breach of any of our industry standard physical, technical or managerial safeguards. When you enter sensitive information (such as log in credentials) on our registration or order forms, we encrypt that information using secure socket layer technology (SSL). No method of transmission over the Internet or method of electronic storage, is 100% secure, however. Therefore, we cannot guarantee its absolute security. If you have any questions about security on our Website, you can contact us. We may use an outside help platform, and a credit card processing company to bill you if you purchase services. These companies do not retain, share, store or use personally identifiable information for any other purposes. We take reasonable measures to protect against the unauthorized access, use, alteration, or destruction of personal information, however, it remains possible that third parties may unlawfully intercept or access transmissions or private communications and may abuse or misuse your personal information that they collect from our Website. Although we work hard to protect your privacy, we cannot guarantee that your personal information or private communications will always remain private.</p>
                    <div className="small-heading" ref={this[`section_7`]}>
                        Social Media Widgets
                    </div>
                    <p>Our Website may include social media features, such as the Facebook ,LinkedIn and Twitter Share buttons and other widgets, that run on our Website. These features may collect your IP address and which page you are visiting on our Website, and may set a cookie to enable the feature to function properly. Social media features and widgets are either hosted by a third-party or hosted directly on our Website. Your interactions with these features are governed by the privacy policy of the organization providing it.</p>
                    <div className="small-heading" ref={this[`section_8`]}>
                        Privacy Shield
                    </div>
                    <p>Syndafy self-certifies compliance with EU-US Privacy Shield at the U.S. Department of Commerce. Syndafy complies with the EU GDPR framework as set forth by the European Union regarding the collection, use, and retention of personal data from European Union member countries. Syndafy has certified that it adheres to the requirements of notice, choice, onward transfer, security, data integrity, access and enforcement.</p>
                    <div className="small-heading" ref={this[`section_9`]}>
                        How You Can Update Your Information console
                    </div>
                    <p>If you are a registered user of our Services, we provide you with tools and account settings to access, correct, delete, or modify the personal information you provided to us and associated with your account.</p>
                    <div className="small-heading" ref={this[`section_10`]}>
                        Links to Other Sites
                    </div>
                    <p>Our Website may include links to other websites that we believe are relevant to our visitors' interests and needs. Please note that we are not responsible for the privacy policies of those other sites.</p>
                    <div className="small-heading" ref={this[`section_11`]}>
                        Privacy Policy Changes
                    </div>
                    <p>
                        Although most changes are likely to be minor, we may change our Privacy Policy from time to time, and at our sole discretion. The most recent version of our Privacy Policy will always be posted on this page and accessible via www.dealgrace.com/privacypolicy and we encourage you to regularly check this page for any changes to our Privacy Policy. If the changes are significant, we will provide a more prominent notice.
                    </p>
                    <div className="small-heading" ref={this[`section_12`]}>
                        How to Contact Us
                    </div>
                    <p>
                        Please email us at <a href="mailto:contact@servicegrace.com" target="_top">contact@servicegrace.com</a> if you have any questions about our Privacy Policy.
                    </p>



                </div>
            </div>
        )
    }
}

function mapStateToProps({ buyer }) {
    //Whatever is returned from this function will end up
    // as props inside of this container component
    return {
        buyerFormData: buyer

    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({

        
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PrivacyPolicyContainer);
